function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Base from "../Base/Base";
import Tooltip from "../Tooltip/Tooltip";
import TooltipContent from "../Tooltip/TooltipContent";
import TooltipContext from "../Tooltip/TooltipContext";
import TooltipSource from "../Tooltip/TooltipSource";
import TooltipTarget from "../Tooltip/TooltipTarget";

function elementHasEllipsis() {
  let ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    current
  } = ref;
  return current && (current.scrollWidth > current.clientWidth || current.scrollHeight > current.clientHeight);
}

export default class EllipsisTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasEllipsis: false
    };
    this.container = /*#__PURE__*/React.createRef();
    this.updateTooltipEnabled = this.updateTooltipEnabled.bind(this);
  }

  updateTooltipEnabled() {
    const hasEllipsis = elementHasEllipsis(this.container);

    if (this.state.hasEllipsis !== hasEllipsis) {
      this.setState({
        hasEllipsis
      });
    }
  }

  onMouseOver() {
    this.updateTooltipEnabled();
  }

  render() {
    const {
      children,
      color,
      delay,
      width,
      theme,
      ...rest
    } = this.props;
    const {
      hasEllipsis
    } = this.state;

    if (!hasEllipsis) {
      return /*#__PURE__*/React.createElement(Base, _extends({
        baseRef: this.container,
        textEllipsis: true
      }, rest, {
        onMouseOver: this.updateTooltipEnabled
      }), children);
    }

    return /*#__PURE__*/React.createElement(Tooltip, {
      delay: delay,
      enabled: true
    }, /*#__PURE__*/React.createElement(TooltipTarget, null, /*#__PURE__*/React.createElement(Base, _extends({
      baseRef: this.container,
      textEllipsis: true
    }, rest), children)), /*#__PURE__*/React.createElement(TooltipSource, {
      theme: theme,
      width: width
    }, /*#__PURE__*/React.createElement(TooltipContext, {
      color: color
    }, /*#__PURE__*/React.createElement(TooltipContent, null, children))));
  }

}

_defineProperty(EllipsisTooltip, "defaultProps", {
  color: "carbon",
  delay: true,
  theme: "night",
  width: "auto"
});